import React from "react";

const FeaturesSection = () => {
  const danceStyles = [
    {
      name: "Reming",
      image: "https://plus.unsplash.com/premium_photo-1681492529719-a1d3d8cc498a?w=600&auto=format&fit=crop&q=60",
    },
    {
      name: "Open Style",
      image: "https://images.unsplash.com/photo-1535525153412-5a42439a210d?w=600&auto=format&fit=crop&q=60",
    },
    {
      name: "Hip Hop",
      image: "https://plus.unsplash.com/premium_photo-1682089706055-d5ef14dc14e4?w=600&auto=format&fit=crop&q=60",
    },
    {
      name: "Contemporary",
      image: "https://plus.unsplash.com/premium_photo-1689885430318-5ce26b2c7c89?w=600&auto=format&fit=crop&q=60",
    },
    {
      name: "Breaking",
      image: "https://images.unsplash.com/photo-1609602886239-a55db9685b7c?w=600&auto=format&fit=crop&q=60",
    },
    {
      name: "Salsa",
      image: "https://plus.unsplash.com/premium_photo-1694558055034-3d6a9cb9df7a?w=600&auto=format&fit=crop&q=60",
    },
    {
      name: "Ballet",
      image: "https://images.unsplash.com/photo-1508807526345-15e9b5f4eaff?q=80&w=2010&auto=format&fit=crop",
    },
    {
      name: "Jazz",
      image: "https://plus.unsplash.com/premium_photo-1689885430776-bbefae37f993?w=600&auto=format&fit=crop&q=60",
    },
  ];

  const handleClick = (styleName) => {
    console.log(`${styleName} clicked!`);
  };

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-gray-800 mb-8 sm:mb-12">
          Learn A Variety of Dance Styles
        </h2>

        {/* Responsive Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 sm:gap-8 md:gap-10">
          {danceStyles.map((style, index) => (
            <div
              key={index}
              className="relative overflow-hidden rounded-lg shadow-lg cursor-pointer group"
              onClick={() => handleClick(style.name)}
            >
              <img
                src={style.image}
                alt={style.name}
                className="w-full h-40 sm:h-48 md:h-52 lg:h-56 object-cover transform transition-transform duration-300 group-hover:scale-110"
              />
              <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <p className="text-white text-lg sm:text-xl md:text-2xl font-bold">
                  {style.name}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
